import { createInertiaApp, http } from '@inertiajs/vue3';
import { initializeTheme } from '@/composables/useAppearance';
import { pageTitle, resolveLayout } from '@/lib/inertiaApp';
import { initializeFlashToast } from '@/lib/flashToast';

void createInertiaApp({
    title: pageTitle,
    withApp: (_app, { page }) => {
        if ('orgAuth' in page.props) {
            http.setClient({ xsrfCookieName: 'ORG-XSRF-TOKEN' });
        }
    },
    layout: resolveLayout,
    progress: {
        // Qrafthive primary (rocket orange), per the LaunchStation design system.
        color: '#D87943',
    },
});

// This will set light / dark mode on page load...
initializeTheme();

// This will listen for flash toast data from the server...
initializeFlashToast();
